import { render, staticRenderFns } from "./SitePostSingle.vue?vue&type=template&id=4105f132&"
import script from "./SitePostSingle.vue?vue&type=script&lang=js&"
export * from "./SitePostSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports